//Turbo.session.drive = false
import "core-js/stable";
import "regenerator-runtime/runtime";
import "debounce";

import M from "materialize-css/dist/js/materialize.min.js";

window.M = M;
window.materializeLoaded = Promise.resolve(M);

import jQuery from "jquery";
window.jQuery = jQuery;
window.$ = jQuery;

import Select2 from "select2";
Select2(window.jQuery);

import "@hotwired/turbo-rails";
import "@hotwired/stimulus";
import "flowbite/dist/flowbite.turbo.js";
// import ahoy from "ahoy.js";

import Rails from "rails-ujs";
import * as ActiveStorage from "activestorage";
import LocalTime from "local-time";
import "@fortawesome/fontawesome-free/js/all";
import "./controllers";
import "./application/javascripts/custom";

Rails.start();
ActiveStorage.start();
LocalTime.start();

import "./channels";

import "trix"
import "@rails/actiontext"
import "ace-builds"
